import React from "react";
import "./ButtonSave.css";
import { Save } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function ButtonSave({
  onClick,
  ariaLabel,
  disabled = false,
  className = "",
  type = "button",
  style,
  isEdit = false,
  isLoading = false,
  withIcon = true,
  iconSize = 20,
}) {
  const { t } = useTranslation('common');
  const computedLabel = isLoading
    ? (isEdit ? t('buttons.updating') : t('buttons.saving'))
    : (isEdit ? t('buttons.update') : t('buttons.save'));
  const computedAria = ariaLabel ?? computedLabel;
  return (
    <button
      type={type}
      onClick={onClick}
      aria-label={computedAria}
      disabled={disabled}
      className={(
        `user-modal-btn user-modal-btn-primary ` +
        `user-level-modal-btn user-level-modal-btn-primary ` +
        className
      ).trim()}
      style={style}
    >
      {withIcon && <Save size={iconSize} aria-hidden="true" />} {computedLabel}
    </button>
  );
}
